export const CANDLI_SEQUENCES = {
  // Save our Oceans Level 1
  '4973bff0-dfb2-11ef-a1e9-837249714301': [
    '6f48841b58af5d8aa450ae5f9258f1ec', 
    '237d32dc23cc59e680ed47ec2e3a4fb5'
  ],
  // Chirpy’s Adventure levels 1-3
  'bee89880-dfaf-11ef-ba63-d9b747d8f3d8' : [ 
    'f4cb3e4fe72355f58e6b58d458d31205',
    'e8d0ab2438765c1c9dd9962d10444a0c',
    '4a95faed0b105822adc1d90c96c4b645'
  ],
  // Math underwater, on land & in the air!
  '1d764820-05c2-11ef-86c1-15e3e190b62a': [
    'c8c710aa7fee5af189791f64fc8270d6', // Chirpy's Adventure Level 1
    '0adb500fa86a5cc6b62ab7ca3680ec64', // Save Our Oceans Level 1
    '4ef94c7e64a95c27b188a00621053697', // Math Invaders
    '1248d7dda51b584eb1596ad3c13a90f5'  // Chirpy's Adventure Level 2
  ],
  // Leveling Up With Math
  '657e1210-05c2-11ef-8cb0-6d54e69f38f6': [
    '376229ad69aa520b9ba8c711c2dbdbb8', // Chirpy's Adventure Level 3
    'e86dfc597c04587b9348952bfdcb76b1', // Save Our Oceans Level 2
    '7a042193eea054b1b85925e074de9b15'  // Magical Mixology
  ],
  // Be a Scientist
  '768f3090-05c0-11ef-86c1-15e3e190b62a': [
    'd145b0ae50ad557ebb6e91931ec42ce8', // Mushroom Mayhem
    '943efee423d75be3bdf761f1e81c7e37', // Gravity Experimentation
    '7160574dc9ec52938f23011a4bcd698f'  // Paper Planes
  ],
  // Thai Leveling Up With Math
  'f93c2f40-0ee7-11ef-bbd8-13a3d43c1666': [
    "4a95faed0b105822adc1d90c96c4b645",
    "237d32dc23cc59e680ed47ec2e3a4fb5",
    "de6a2f6f709e57a1b3aa6358a5a8d0bb"
  ],
  // Thai Math underwater, on land & in the air!
  '87f37b90-0ee7-11ef-bbd8-13a3d43c1666': [
    "f4cb3e4fe72355f58e6b58d458d31205",
    "6f48841b58af5d8aa450ae5f9258f1ec",
    "5f4092d3956e53c98ccec3da0a2f3925",
    "e8d0ab2438765c1c9dd9962d10444a0c"
  ],
  // Thai Be a Scientist
  'b56c1100-0ee6-11ef-bbd8-13a3d43c1666': [
    "a1c31030facc58d688a07040e25771db",
    "93690465d42f52058c92404e329651be",
    "ba07adc0589f5f3a990f995cc54b8efd"
  ],
  // Pethematicians
  "e7bd0050-1bb1-11f0-a107-d7050efaf0bb": [
    "97c9ab96e9c75cd485d50d0c51fa7004"
  ],
  // Thai Pethematicians
  "f73759d0-24d1-11f0-a6bf-e576da95b533": [
    "97c9ab96e9c75cd485d50d0c51fa7004"
  ],
  // Incredible Machines
  "61b84150-0959-11f0-9713-5b1a5f06cc0f": [
    "candli_editor/incredible_machine0",
    "candli_editor/incredible_machine1",
    "candli_editor/incredible_machine2"
  ],
  // Thai Incredible Machines
  "d153bd60-1f56-11f0-9fb8-9370197aa135": [
    "candli_editor/incredible_machine0",
    "candli_editor/incredible_machine1",
    "candli_editor/incredible_machine2"
  ],
}

export const GEN_AI_SEQUENCES = {
  '085f62f0-87a4-11ef-861e-a9ea128200f7': true
}

export const ADMIN_TAG = "36e1b060-ed49-11ee-be89-5b04faf266ea"
export const TEACHER_TAG = "49bf66a0-ed49-11ee-be89-5b04faf266ea"
export const TRAINER_TAG = "8ae541e0-ed49-11ee-be89-5b04faf266ea"
export const THAI_TEACHER_LABEL = "bc66acf0-7249-11f0-a043-df27bf1150f5"
export const PILA_CONTENT_TAG = "1a53db50-e248-11ee-ab5f-07f4a7408770"
export const MANDATORY_RESOURCES_TAG = "24af6b80-1174-11f0-9b08-0156640831c5"
export const OPTIONAL_RESOURCES_TAG = "e5e89470-11ab-11f0-bd10-df9c846cb093"
export const MY_CONTENT_TAG = '86220090-480f-11f0-a2e7-298d7c5ad755'

export const EXPERT_LIST = [
  'f74e9cb3-2b53-4c85-9b0c-f1d61b032b3f'
]

export const DEFAULT_CODE_LIST = []
export const DOMAIN_CODE_LISTS = {
  'app.pilaproject.org': [ 'ACCESS', 'PILA23', 'PILA4Learning23!' ],
  'thailand.pilaproject.org': ['THAI_ACCESS', 'thai_access'],
  'f74e9cb3-2b53-4c85-9b0c-f1d61b032b3f.localhost:9898': ['jason', 'thai_access'],
  'polska-rct-2025.pilaproject.org': ['25-DOSTEP-RCT'],
  'france-rct-2025.pilaproject.org': ['25-ACCES-RCT']
}

export const DOMAIN_DATA_PROTECTION_LINKS = {
  'thailand.pilaproject.org': 'https://pilaproject.org/about-pila/thailand-data-protection-notice-for-teachers',
  default: 'https://pilaproject.org/about-pila/data-protection-notice-for-teachers'
}

export const HOST_TO_TITLE = {
  'f74e9cb3-2b53-4c85-9b0c-f1d61b032b3f.localhost:9898': 'International',
  'app.pilaproject.org': 'International',
  'cambodia.pilaproject.org': 'កម្ពុជា',
  'thailand.pilaproject.org': 'ประเทศไทย',
  'polska-rct-2025.pilaproject.org': 'RCT Polska'
}

export const HOST_TO_PARTITION = {
  'f74e9cb3-2b53-4c85-9b0c-f1d61b032b3f.localhost:9898' : 'PILA',
  'app.pilaproject.org': 'PILA',
  'cambodia.pilaproject.org': 'PILA Cambodia',
  'thailand.pilaproject.org': 'PILA Thailand',
  'polska-rct-2025.pilaproject.org': 'PILA Poland RCT 2025',
  'france-rct-2025.pilaproject.org': 'PILA France RCT 2025'
}

export const SIMPLIFIED_STUDY_DOMAINS = [
  'polska-rct-2025.pilaproject.org',
  'france-rct-2025.pilaproject.org'
  //'f74e9cb3-2b53-4c85-9b0c-f1d61b032b3f.localhost:9898'
]

export const HOST_TO_EXTRA_TEACHER_TAGS = {
  'thailand.pilaproject.org': [
    {
      id: THAI_TEACHER_LABEL,
      editable: true,
      values: [
        { label: 'teacher' },
        { label: 'supervisor' },
        { label: 'core-facilitator' }
      ]
    }
  ]
}
